import PageTitle from "@/components/PageTitle";
import SideBarWrapper from "@/components/SideBarWrapper";
import { Briefcase, ChartArea, FolderOpenDot } from "lucide-react";
import { Listing } from "./Listing";

const Companies = () => {
  return (
    <SideBarWrapper>
      <div className="LookUpTabs">
        <div className="content-lookups xl:p-5 p-3">
          <>
            <div>
              <div className="card mb-5 p-3">
                <PageTitle icon={Briefcase} pageTitle="Companies" />
              </div>
              <Listing />
            </div>
          </>
        </div>
      </div>
    </SideBarWrapper>
  );
};

export default Companies;
